import { render, staticRenderFns } from "./ChatBoxMention.vue?vue&type=template&id=488dff56&scoped=true&"
import script from "./ChatBoxMention.vue?vue&type=script&lang=js&"
export * from "./ChatBoxMention.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxMention.vue?vue&type=style&index=0&id=488dff56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488dff56",
  null
  
)

export default component.exports